var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard42(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_42);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #656fb2;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_42",
    "data-name": "Artboard \\u2013 42",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493",
    transform: "translate(-10918.96 -6784.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    className: "cls-2",
    d: "M364.269,70.044h-1.461v-.731a.73.73,0,1,0-1.461,0v.731h-4.383v-.731a.731.731,0,1,0-1.461,0v.731h-1.461a2.194,2.194,0,0,0-2.192,2.192V82.463a2.194,2.194,0,0,0,2.192,2.192h10.227a2.194,2.194,0,0,0,2.192-2.192V72.236A2.194,2.194,0,0,0,364.269,70.044ZM365,82.463a.731.731,0,0,1-.73.731H354.042a.731.731,0,0,1-.731-.731V75.888h3.319a.845.845,0,0,0-.044.259v2.736a.85.85,0,1,0,1.7,0V76.147a.845.845,0,0,0-.044-.259h1.83a.832.832,0,0,0-.045.259v2.736a.85.85,0,0,0,1.7,0V76.147a.831.831,0,0,0-.045-.259H365Zm0-8.036H353.311V72.236a.731.731,0,0,1,.731-.731H355.5v.731a.731.731,0,1,0,1.461,0v-.731h4.383v.731a.73.73,0,1,0,1.461,0v-.731h1.461a.731.731,0,0,1,.73.731Z",
    transform: "translate(10580.984 6729.333)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34-2",
    "data-name": "Ellipse 34-2",
    className: "cls-3",
    cx: 7.6,
    cy: 7.6,
    r: 7.6,
    transform: "translate(10925.476 6791.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    className: "cls-2",
    d: "M246.187,72.537h-2.395V70.142a.627.627,0,0,0-.6-.6h-.6a.627.627,0,0,0-.6.6v2.395H239.6a.627.627,0,0,0-.6.6v.6a.627.627,0,0,0,.6.6H242v2.395a.627.627,0,0,0,.6.6h.6a.627.627,0,0,0,.6-.6V74.333h2.395a.627.627,0,0,0,.6-.6v-.6A.627.627,0,0,0,246.187,72.537Z",
    transform: "translate(10690.581 6726.393)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard42);
export default __webpack_public_path__ + "static/media/Artboard – 42.606b01447a5a57000d38764fcd845834.svg";
export { ForwardRef as ReactComponent };